import React, { useEffect, useCallback } from 'react';
import { Snackbar, Alert, Box } from '@mui/material';
import { useBot } from '../contexts/BotContext';

const NotificationSystem = () => {
  const context = useBot();
  const { notifications, api } = context;

  const handleClose = useCallback((notificationId) => {
    api.clearNotification(notificationId);
  }, [api]);

  // Auto-remove notifications after 5 seconds
  useEffect(() => {
    const timeouts = notifications.map(notification => 
      setTimeout(() => {
        handleClose(notification.id);
      }, 5000)
    );

    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
  }, [notifications, handleClose]);

  return (
    <Box>
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={5000}
          onClose={() => handleClose(notification.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={{ mt: 1 }}
        >
          <Alert
            onClose={() => handleClose(notification.id)}
            severity={notification.type}
            variant="filled"
            sx={{ width: '100%' }}
          >
            <Box>
              <Box sx={{ fontWeight: 'bold', mb: 0.5 }}>
                {notification.title}
              </Box>
              <Box sx={{ fontSize: '0.875rem' }}>
                {notification.message}
              </Box>
            </Box>
          </Alert>
        </Snackbar>
      ))}
    </Box>
  );
};

export default NotificationSystem;
 

